import api from './index'
import type { V1ApiResponse } from '@/types'

export interface AppVersionDetailImage {
  mediaResourceId: number
  mediaUrl: string
  mediaType?: number | null
  coverUrl?: string | null
  sort: number
}

export interface AppVersionChannel {
  appChannelId: number
  channelCode: string
  channelName: string
  channelId: string
  packageName: string
  channelUrl: string
  channelDescription?: string | null
}

export interface AppVersionUpdate {
  appVersionId: number
  platformType: number
  versionNumber: string
  minimumRequiredVersionNumber: string
  forceUpdate: boolean
  featureIntroduction: string
  characteristicIntroduction?: string | null
  detailImages?: AppVersionDetailImage[]
  channel?: AppVersionChannel | null
}

export const appVersionApi = {
  queryUpdate: (): Promise<V1ApiResponse<AppVersionUpdate | null>> =>
    api.get('/v1/app-versions/update', {
      noAuthRedirect: true,
    } as any),
}

export default appVersionApi
